import { useEffect, useState, useRef } from 'react';
import ModalOpcionesImpresion from '../../components/impresion/ModalOpcionesImpresion';
import ModalAccionesPago from '../../components/ModalAccionesPago';
import { clienteService, pagoService, prestamoService } from '../../services/api';
import '../../styles/Pagos.css';

const Pago = () => {
  const [clientes, setClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState('');
  const [prestamos, setPrestamos] = useState([]);
  const [prestamoSeleccionado, setPrestamoSeleccionado] = useState(null);
  const [busquedaId, setBusquedaId] = useState('');
  const [pagarCapital, setPagarCapital] = useState(true);
  const [pagarInteres, setPagarInteres] = useState(true);
  const [busquedaCliente, setBusquedaCliente] = useState('');
  const [mostrarDropdown, setMostrarDropdown] = useState(false);
  const [clienteObj, setClienteObj] = useState(null);
  const [formData, setFormData] = useState({
    monto_capital: '',
    monto_interes: '',
    monto_mora: '',
    monto_total: '',
    tipo_pago: 'normal',
    fecha_pago: new Date().toISOString().split('T')[0],
    detalle: ''
  });
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });

  // Estados para el modal de impresión
  const [mostrarModalImpresion, setMostrarModalImpresion] = useState(false);
  const [opcionesImpresion, setOpcionesImpresion] = useState(null);
  const [whatsappData, setWhatsappData] = useState(null);

  // Estados para el modal de acciones después del pago
  const [mostrarModalAcciones, setMostrarModalAcciones] = useState(false);
  const [datosPagoGuardado, setDatosPagoGuardado] = useState(null);

  // Ref para evitar loops infinitos en useEffect
  const isCalculating = useRef(false);

  useEffect(() => {
    cargarClientes();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.busqueda-cliente')) {
        setMostrarDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const cargarClientes = async () => {
    try {
      const response = await clienteService.getAll({ per_page: 1000 });
      setClientes(response.data.clientes || []);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
    }
  };

  const clientesFiltrados = clientes.filter(cliente => {
    const termino = busquedaCliente.toLowerCase().trim();
    if (!termino) return true;

    return (
      (cliente.nombres && cliente.nombres.toLowerCase().includes(termino)) ||
      (cliente.apellidos && cliente.apellidos.toLowerCase().includes(termino)) ||
      (cliente.cedula && cliente.cedula.includes(termino)) ||
      (cliente.apodo && cliente.apodo.toLowerCase().includes(termino)) ||
      cliente.id.toString().includes(termino) ||
      (cliente.nombres && cliente.apellidos &&
       `${cliente.nombres} ${cliente.apellidos}`.toLowerCase().includes(termino))
    );
  }).slice(0, 10);

  const seleccionarCliente = async (cliente) => {
    setClienteObj(cliente);
    setBusquedaCliente(`${cliente.nombres} ${cliente.apellidos} - ${cliente.cedula}`);
    setMostrarDropdown(false);
    setClienteSeleccionado(cliente.id);
    setPrestamos([]);
    setPrestamoSeleccionado(null);

    try {
      const response = await prestamoService.getAll({ cliente_id: cliente.id });
      const prestamosActivos = (response.data.prestamos || []).filter(
        p => p.estado === 'activo'
      );
      setPrestamos(prestamosActivos);
    } catch (error) {
      console.error('Error al cargar préstamos:', error);
    }
  };

  const limpiarCliente = () => {
    setClienteObj(null);
    setClienteSeleccionado('');
    setBusquedaCliente('');
    setPrestamos([]);
    setPrestamoSeleccionado(null);
  };

  const handleBuscarPorId = async () => {
    console.log('=== INICIO handleBuscarPorId ===');
    console.log('busquedaId:', busquedaId);
    
    if (!busquedaId) {
      console.log('❌ ID vacío');
      setMensaje({ tipo: 'error', texto: 'Por favor ingrese un ID de préstamo' });
      return;
    }

    try {
      console.log('🔍 Limpiando mensajes previos');
      setMensaje({ tipo: '', texto: '' }); // Limpiar mensajes previos
      
      console.log('🌐 Llamando API: prestamoService.getById(' + busquedaId + ')');
      const response = await prestamoService.getById(busquedaId);
      console.log('📥 Respuesta recibida:', response);
      
      if (!response || !response.data) {
        console.log('❌ Respuesta vacía o sin data');
        setMensaje({ tipo: 'error', texto: 'Préstamo no encontrado' });
        return;
      }

      const prestamo = response.data;
      console.log('✅ Préstamo obtenido:', prestamo);
      console.log('- ID:', prestamo.id);
      console.log('- Estado:', prestamo.estado);
      console.log('- Cuotas:', prestamo.cuotas);
      console.log('- Total:', prestamo.total);
      console.log('- Capital:', prestamo.capital);
      console.log('- Interés:', prestamo.interes);

      // Validar que el préstamo tenga las propiedades necesarias
      if (!prestamo.cuotas || prestamo.cuotas === 0) {
        console.log('❌ Cuotas inválidas');
        setMensaje({ tipo: 'error', texto: 'El préstamo no tiene cuotas válidas' });
        return;
      }

      if (!prestamo.total || prestamo.total === 0) {
        console.log('❌ Total inválido');
        setMensaje({ tipo: 'error', texto: 'El préstamo no tiene un total válido' });
        return;
      }

      if (prestamo.estado === 'activo') {
        console.log('✅ Préstamo activo, seleccionando...');
        setPrestamoSeleccionado(prestamo);
        console.log('✅ Préstamo seleccionado, calculando montos...');
        calcularMontos(prestamo);
        console.log('✅ Montos calculados, mostrando mensaje de éxito');
        setMensaje({ tipo: 'success', texto: 'Préstamo encontrado exitosamente' });
      } else {
        console.log('❌ Préstamo no activo:', prestamo.estado);
        setMensaje({ tipo: 'error', texto: `Este préstamo no está activo. Estado: ${prestamo.estado || 'desconocido'}` });
      }
      console.log('=== FIN handleBuscarPorId (ÉXITO) ===');
    } catch (error) {
      console.log('=== ERROR EN handleBuscarPorId ===');
      console.error('Error completo:', error);
      console.error('Error.message:', error.message);
      console.error('Error.response:', error.response);
      const errorMessage = error.response?.data?.error || error.message || 'Error al buscar el préstamo';
      setMensaje({ tipo: 'error', texto: errorMessage });
      setPrestamoSeleccionado(null);
      console.log('=== FIN handleBuscarPorId (ERROR) ===');
    }
  };

  const handleSeleccionarPrestamo = (prestamo) => {
    setPrestamoSeleccionado(prestamo);
    calcularMontos(prestamo);
  };

  const calcularMontos = (prestamo) => {
    try {
      // Validar que el préstamo tenga las propiedades necesarias
      if (!prestamo || !prestamo.cuotas || prestamo.cuotas === 0) {
        console.error('Préstamo inválido o sin cuotas:', prestamo);
        setMensaje({ tipo: 'error', texto: 'Error: El préstamo no tiene cuotas válidas' });
        return;
      }

      // Valores por defecto si faltan propiedades
      const cuotas = prestamo.cuotas || 1;
      const cuotasPagadas = prestamo.cuotas_pagadas || 0;
      const total = parseFloat(prestamo.total) || 0;
      const capital = parseFloat(prestamo.capital) || 0;
      const interes = parseFloat(prestamo.interes) || 0;

      const cuotasPendientes = cuotas - cuotasPagadas;
      const montoCuota = cuotas > 0 ? total / cuotas : 0;
      const capitalCuota = cuotas > 0 ? capital / cuotas : 0;
      const interesCuota = cuotas > 0 ? interes / cuotas : 0;

      setPagarCapital(true);
      setPagarInteres(true);

      setFormData({
        ...formData,
        monto_capital: capitalCuota.toFixed(2),
        monto_interes: interesCuota.toFixed(2),
        monto_mora: '0.00',
        monto_total: montoCuota.toFixed(2)
      });
    } catch (error) {
      console.error('Error al calcular montos:', error);
      setMensaje({ tipo: 'error', texto: 'Error al calcular los montos del préstamo' });
    }
  };

  // Efecto para recalcular el total cuando cambian los checkboxes
  useEffect(() => {
    if (isCalculating.current) return; // Evitar loop infinito
    
    if (prestamoSeleccionado && prestamoSeleccionado.cuotas && prestamoSeleccionado.cuotas > 0) {
      try {
        isCalculating.current = true;
        
        const cuotas = prestamoSeleccionado.cuotas;
        const capital = parseFloat(prestamoSeleccionado.capital) || 0;
        const interes = parseFloat(prestamoSeleccionado.interes) || 0;

        const capitalCuota = capital / cuotas;
        const interesCuota = interes / cuotas;

        const montoCapital = pagarCapital ? capitalCuota : 0;
        const montoInteres = pagarInteres ? interesCuota : 0;
        const montoTotal = montoCapital + montoInteres;

        setFormData(prev => ({
          ...prev,
          monto_capital: montoCapital.toFixed(2),
          monto_interes: montoInteres.toFixed(2),
          monto_total: montoTotal.toFixed(2)
        }));
        
        setTimeout(() => {
          isCalculating.current = false;
        }, 100);
      } catch (error) {
        console.error('Error al recalcular montos en useEffect:', error);
        isCalculating.current = false;
      }
    }
  }, [pagarCapital, pagarInteres, prestamoSeleccionado]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Si se cambia el tipo de pago a "solo_interes", ajustar los montos
    if (name === 'tipo_pago' && value === 'solo_interes' && prestamoSeleccionado) {
      const interesCuota = prestamoSeleccionado.interes / prestamoSeleccionado.cuotas;
      setFormData({
        ...formData,
        tipo_pago: value,
        monto_capital: '0.00',
        monto_interes: interesCuota.toFixed(2),
        monto_total: interesCuota.toFixed(2)
      });
      return;
    }

    // Si se cambia de "solo_interes" a "normal", recalcular montos normales
    if (name === 'tipo_pago' && formData.tipo_pago === 'solo_interes' && value === 'normal' && prestamoSeleccionado) {
      calcularMontos(prestamoSeleccionado);
      setFormData(prev => ({ ...prev, tipo_pago: value }));
      return;
    }

    setFormData({ ...formData, [name]: value });

    // Recalcular total si cambian los montos
    if (['monto_capital', 'monto_interes', 'monto_mora'].includes(name)) {
      const capital = parseFloat(name === 'monto_capital' ? value : formData.monto_capital) || 0;
      const interes = parseFloat(name === 'monto_interes' ? value : formData.monto_interes) || 0;
      const mora = parseFloat(name === 'monto_mora' ? value : formData.monto_mora) || 0;
      setFormData(prev => ({
        ...prev,
        [name]: value,
        monto_total: (capital + interes + mora).toFixed(2)
      }));
    }
  };

  const submitPago = async (e) => {
    e.preventDefault();

    if (!prestamoSeleccionado) {
      setMensaje({ tipo: 'error', texto: 'Debe seleccionar un préstamo' });
      return;
    }

    if (!pagarCapital && !pagarInteres) {
      setMensaje({ tipo: 'error', texto: 'Debe seleccionar al menos Capital o Interés' });
      return;
    }

    // CONFIRMACIÓN ANTES DE GUARDAR
    const nombreCliente = prestamoSeleccionado.cliente ? 
      `${prestamoSeleccionado.cliente.nombres} ${prestamoSeleccionado.cliente.apellidos}` : 
      'Cliente';
    
    const confirmacion = window.confirm(
      `¿REGISTRAR PAGO?\n\n` +
      `Cliente: ${nombreCliente.toUpperCase()}\n` +
      `Préstamo ID: ${prestamoSeleccionado.id}\n` +
      `Tipo de pago: ${formData.tipo_pago}\n` +
      `Monto Capital: $${parseFloat(formData.monto_capital).toFixed(2)}\n` +
      `Monto Interés: $${parseFloat(formData.monto_interes).toFixed(2)}\n` +
      `Monto Mora: $${parseFloat(formData.monto_mora).toFixed(2)}\n` +
      `Total a pagar: $${parseFloat(formData.monto_total).toFixed(2)}\n\n` +
      `¿Desea continuar?`
    );

    if (!confirmacion) {
      return;
    }

    try {
      const data = {
        prestamo_id: prestamoSeleccionado.id,
        ...formData,
        monto_capital: parseFloat(formData.monto_capital),
        monto_interes: parseFloat(formData.monto_interes),
        monto_mora: parseFloat(formData.monto_mora),
        monto_total: parseFloat(formData.monto_total)
      };

      const response = await pagoService.create(data);
      setMensaje({ tipo: 'success', texto: '✅ PAGO REGISTRADO EXITOSAMENTE' });

      // Guardar datos para el modal de acciones
      setDatosPagoGuardado({
        nombreCliente,
        prestamoId: prestamoSeleccionado.id,
        montoPagado: parseFloat(formData.monto_total),
        cuotasPagadas: prestamoSeleccionado.cuotas_pagadas + 1,
        totalCuotas: prestamoSeleccionado.cuotas,
        pagoId: response.data.id,
        cliente: prestamoSeleccionado.cliente,
        prestamo: prestamoSeleccionado
      });

      // Mostrar modal de acciones
      setMostrarModalAcciones(true);

    } catch (error) {
      setMensaje({ tipo: 'error', texto: error.response?.data?.error || 'Error al registrar el pago' });
    }
  };

  const limpiarFormularioDespuesDePago = () => {
    setPrestamoSeleccionado(null);
    setPagarCapital(true);
    setPagarInteres(true);
    setFormData({
      monto_capital: '',
      monto_interes: '',
      monto_mora: '',
      monto_total: '',
      tipo_pago: 'normal',
      fecha_pago: new Date().toISOString().split('T')[0],
      detalle: ''
    });
    setBusquedaId('');
    setClienteSeleccionado('');
    setPrestamos([]);
    setBusquedaCliente('');
    setClienteObj(null);
  };

  const handleCerrarModalAcciones = () => {
    setMostrarModalAcciones(false);
    limpiarFormularioDespuesDePago();
  };

  const handleImprimirRecibo = () => {
    if (datosPagoGuardado) {
      window.open(`/recibo/${datosPagoGuardado.pagoId}`, '_blank');
    }
  };

  const handleEnviarWhatsApp = () => {
    if (datosPagoGuardado && datosPagoGuardado.cliente) {
      const celular = datosPagoGuardado.cliente.celular;
      if (!celular) {
        alert('❌ El cliente no tiene número de celular registrado');
        return;
      }

      const mensaje = 
        `✅ *Pago Registrado*\n\n` +
        `Cliente: ${datosPagoGuardado.nombreCliente}\n` +
        `Préstamo ID: ${datosPagoGuardado.prestamoId}\n` +
        `Monto pagado: $${datosPagoGuardado.montoPagado.toFixed(2)}\n` +
        `Cuotas pagadas: ${datosPagoGuardado.cuotasPagadas}/${datosPagoGuardado.totalCuotas}\n\n` +
        `¡Gracias por su pago!`;

      // Normalizar número (solo dígitos) y asegurar código de país RD/US (+1)
      const soloDigitos = celular.replace(/\D/g, '');
      const numeroWhatsApp = soloDigitos.startsWith('1') ? soloDigitos : `1${soloDigitos}`;

      // Detectar si es móvil
      const esMovil = /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);

      // En móviles, intentar abrir directamente la app de WhatsApp; si falla, usar wa.me
      if (esMovil) {
        const appUrl = `whatsapp://send?phone=${numeroWhatsApp}&text=${encodeURIComponent(mensaje)}`;
        // Abrir en la misma pestaña para permitir deep-link; si no existe la app, el sistema no abrirá
        window.location.href = appUrl;
        // Fallback a wa.me tras un breve delay
        setTimeout(() => {
          const webUrl = `https://wa.me/${numeroWhatsApp}?text=${encodeURIComponent(mensaje)}`;
          window.open(webUrl, '_blank');
        }, 600);
      } else {
        // En desktop usar web.whatsapp (o wa.me)
        const webUrl = `https://web.whatsapp.com/send?phone=${numeroWhatsApp}&text=${encodeURIComponent(mensaje)}`;
        window.open(webUrl, '_blank');
      }
    }
  };

  return (
    <div className="pago-container">
      <h2>Registro de Pago</h2>

      {mensaje.texto && (
        <div className={`mensaje ${mensaje.tipo}`}>
          {mensaje.texto}
        </div>
      )}

      <div className="busqueda-section">
        <div className="busqueda-cliente">
          <label>Buscar por Cliente:</label>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por nombre, cédula, apodo o ID..."
              value={busquedaCliente}
              onChange={(e) => {
                setBusquedaCliente(e.target.value);
                setMostrarDropdown(true);
              }}
              onFocus={() => setMostrarDropdown(true)}
            />
            {clienteObj && (
              <button
                type="button"
                onClick={limpiarCliente}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  fontSize: '20px',
                  cursor: 'pointer',
                  color: '#6c757d'
                }}
              >
                ×
              </button>
            )}

            {mostrarDropdown && busquedaCliente && clientesFiltrados.length > 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: 'white',
                border: '1px solid #ddd',
                borderRadius: '4px',
                maxHeight: '400px',
                overflowY: 'auto',
                zIndex: 1000,
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}>
                {clientesFiltrados.map((cliente) => (
                  <div
                    key={cliente.id}
                    onClick={() => seleccionarCliente(cliente)}
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f0f0f0',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    {cliente.foto_url ? (
                      <img
                        src={cliente.foto_url}
                        alt={cliente.nombres}
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                      />
                    ) : (
                      <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: '#007bff',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold'
                      }}>
                        {cliente.nombres?.charAt(0)}{cliente.apellidos?.charAt(0)}
                      </div>
                    )}
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 'bold' }}>
                        {cliente.nombres} {cliente.apellidos}
                        {cliente.apodo && (
                          <span style={{
                            marginLeft: '8px',
                            color: '#007bff',
                            fontStyle: 'italic',
                            fontWeight: 'normal'
                          }}>
                            ({cliente.apodo})
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: '0.9em', color: '#666' }}>
                        Cédula: {cliente.cedula} • ID: {cliente.id}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="separador">O</div>

        <div className="busqueda-id">
          <label>Buscar por ID de Préstamo:</label>
          <form onSubmit={(e) => { e.preventDefault(); handleBuscarPorId(); }}>
            <div className="input-group">
              <input
                type="text"
                value={busquedaId}
                onChange={(e) => setBusquedaId(e.target.value)}
                placeholder="ID del préstamo"
              />
              <button type="submit">Buscar</button>
            </div>
          </form>
        </div>
      </div>

      {prestamos.length > 0 && (
        <div className="prestamos-list">
          <h3>Préstamos Activos del Cliente</h3>
          {prestamos.map(prestamo => (
            <div
              key={prestamo.id}
              className={`prestamo-item ${prestamoSeleccionado?.id === prestamo.id ? 'selected' : ''} ${prestamo.cuotas_pagadas > 0 ? 'con-pagos' : ''}`}
              onClick={() => handleSeleccionarPrestamo(prestamo)}
              style={prestamo.cuotas_pagadas > 0 ? {
                backgroundColor: '#d4edda',
                borderColor: '#28a745'
              } : {}}
            >
              <div><strong>ID:</strong> {prestamo.id}</div>
              <div><strong>Monto:</strong> ${(prestamo.total || 0).toFixed(2)}</div>
              <div><strong>Cuotas:</strong> {prestamo.cuotas_pagadas || 0}/{prestamo.cuotas || 0}</div>
              <div><strong>Tipo:</strong> {prestamo.tipo || 'N/A'}</div>
            </div>
          ))}
        </div>
      )}

      {prestamoSeleccionado && (
        <form onSubmit={submitPago} className="pago-form">
          <div className="prestamo-info">
            <h3>Información del Préstamo</h3>
            <div style={{display: 'flex', gap: '2rem', alignItems: 'flex-start'}}>
              {/* Foto del cliente */}
              {prestamoSeleccionado.cliente?.foto_perfil && (
                <div style={{flexShrink: 0}}>
                  <img
                    src={prestamoSeleccionado.cliente.foto_perfil}
                    alt={`${prestamoSeleccionado.cliente?.nombres} ${prestamoSeleccionado.cliente?.apellidos}`}
                    style={{
                      width: '120px',
                      height: '120px',
                      borderRadius: '8px',
                      objectFit: 'cover',
                      border: '2px solid #ddd'
                    }}
                  />
                  <p style={{textAlign: 'center', marginTop: '0.5rem', fontSize: '0.9rem'}}>
                    {prestamoSeleccionado.cliente?.nombres} {prestamoSeleccionado.cliente?.apellidos}
                  </p>
                </div>
              )}

              {/* Información del préstamo */}
              <div className="info-grid" style={{flex: 1}}>
                <div><strong>ID:</strong> {prestamoSeleccionado.id || 'N/A'}</div>
                <div><strong>Cliente ID:</strong> {prestamoSeleccionado.cliente_id || prestamoSeleccionado.cliente?.id || 'N/A'}</div>
                <div><strong>Capital:</strong> ${((prestamoSeleccionado.capital || 0)).toFixed(2)}</div>
                <div><strong>Total:</strong> ${((prestamoSeleccionado.total || 0)).toFixed(2)}</div>
                <div><strong>Cuota:</strong> ${(prestamoSeleccionado.cuotas && prestamoSeleccionado.cuotas > 0 ? (prestamoSeleccionado.total || 0) / prestamoSeleccionado.cuotas : 0).toFixed(2)}</div>
                <div><strong>Cuotas:</strong> {prestamoSeleccionado.cuotas_pagadas || 0}/{prestamoSeleccionado.cuotas || 0}</div>
              </div>
            </div>

            {/* Barra de progreso */}
            <div style={{marginTop: '1rem'}}>
              <div style={{
                width: '100%',
                height: '20px',
                backgroundColor: '#e0e0e0',
                borderRadius: '10px',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: `${(prestamoSeleccionado.cuotas && prestamoSeleccionado.cuotas > 0 ? ((prestamoSeleccionado.cuotas_pagadas || 0) / prestamoSeleccionado.cuotas) * 100 : 0)}%`,
                  height: '100%',
                  backgroundColor: '#4caf50',
                  transition: 'width 0.3s ease'
                }}></div>
              </div>
              <p style={{textAlign: 'center', marginTop: '0.5rem', fontSize: '0.9rem'}}>
                {(prestamoSeleccionado.cuotas && prestamoSeleccionado.cuotas > 0 ? (((prestamoSeleccionado.cuotas_pagadas || 0) / prestamoSeleccionado.cuotas) * 100).toFixed(0) : 0)}% completado
              </p>
            </div>
          </div>

          {/* Opciones de pago */}
          <div style={{
            marginBottom: '1.5rem',
            padding: '1rem',
            backgroundColor: '#f5f5f5',
            borderRadius: '8px'
          }}>
            <h4 style={{marginTop: 0, marginBottom: '1rem'}}>¿Qué desea pagar?</h4>
            <div style={{display: 'flex', gap: '1rem'}}>
              <label style={{
                display: 'flex',
                alignItems: 'center',
                padding: '0.75rem',
                flex: 1,
                backgroundColor: pagarCapital ? '#e3f2fd' : 'white',
                borderRadius: '8px',
                cursor: 'pointer',
                border: pagarCapital ? '2px solid #2196F3' : '2px solid #ddd',
                transition: 'all 0.2s'
              }}>
                <input
                  type="checkbox"
                  checked={pagarCapital}
                  onChange={(e) => setPagarCapital(e.target.checked)}
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '0.75rem',
                    cursor: 'pointer'
                  }}
                />
                <div>
                  <div style={{fontWeight: 'bold', color: '#333'}}>Capital</div>
                  <div style={{fontSize: '0.85rem', color: '#666'}}>
                    DOP {(prestamoSeleccionado.cuotas && prestamoSeleccionado.cuotas > 0 ? ((prestamoSeleccionado.capital || 0) / prestamoSeleccionado.cuotas).toFixed(2) : '0.00')}
                  </div>
                </div>
              </label>

              <label style={{
                display: 'flex',
                alignItems: 'center',
                padding: '0.75rem',
                flex: 1,
                backgroundColor: pagarInteres ? '#e8f5e9' : 'white',
                borderRadius: '8px',
                cursor: 'pointer',
                border: pagarInteres ? '2px solid #4CAF50' : '2px solid #ddd',
                transition: 'all 0.2s'
              }}>
                <input
                  type="checkbox"
                  checked={pagarInteres}
                  onChange={(e) => setPagarInteres(e.target.checked)}
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '0.75rem',
                    cursor: 'pointer'
                  }}
                />
                <div>
                  <div style={{fontWeight: 'bold', color: '#333'}}>Interés</div>
                  <div style={{fontSize: '0.85rem', color: '#666'}}>
                    DOP {(prestamoSeleccionado.cuotas && prestamoSeleccionado.cuotas > 0 ? ((prestamoSeleccionado.interes || 0) / prestamoSeleccionado.cuotas).toFixed(2) : '0.00')}
                  </div>
                </div>
              </label>
            </div>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label>Monto Capital:</label>
              <input
                type="number"
                name="monto_capital"
                value={formData.monto_capital}
                onChange={handleChange}
                step="0.01"
                required
                readOnly={formData.tipo_pago === 'solo_interes'}
                style={formData.tipo_pago === 'solo_interes' ? { backgroundColor: '#f0f0f0' } : {}}
              />
            </div>

            <div className="form-group">
              <label>Monto Interés:</label>
              <input
                type="number"
                name="monto_interes"
                value={formData.monto_interes}
                onChange={handleChange}
                step="0.01"
                required
              />
            </div>

            <div className="form-group">
              <label>Monto Mora:</label>
              <input
                type="number"
                name="monto_mora"
                value={formData.monto_mora}
                onChange={handleChange}
                step="0.01"
              />
            </div>

            <div className="form-group">
              <label>Monto Total:</label>
              <input
                type="number"
                name="monto_total"
                value={formData.monto_total}
                onChange={handleChange}
                step="0.01"
                required
                readOnly
              />
            </div>

            <div className="form-group">
              <label>Tipo de Pago:</label>
              <select
                name="tipo_pago"
                value={formData.tipo_pago}
                onChange={handleChange}
                required
              >
                <option value="normal">Normal</option>
                <option value="solo_interes">Solo Interés</option>
                <option value="extraordinario">Extraordinario</option>
                <option value="adelanto">Adelanto</option>
              </select>
            </div>

            <div className="form-group">
              <label>Fecha de Pago:</label>
              <input
                type="date"
                name="fecha_pago"
                value={formData.fecha_pago}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group full-width">
              <label>Detalle (opcional):</label>
              <textarea
                name="detalle"
                value={formData.detalle}
                onChange={handleChange}
                rows="3"
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-primary">Registrar Pago</button>
            <button
              type="button"
              className="btn-secondary"
              onClick={() => {
                setPrestamoSeleccionado(null);
                setFormData({
                  monto_capital: '',
                  monto_interes: '',
                  monto_mora: '',
                  monto_total: '',
                  tipo_pago: 'normal',
                  fecha_pago: new Date().toISOString().split('T')[0],
                  detalle: ''
                });
              }}
            >
              Cancelar
            </button>
          </div>
        </form>
      )}

      {/* Modal de opciones de impresión */}
      {mostrarModalImpresion && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999, backgroundColor: 'rgba(255,0,0,0.8)' }}>
          <ModalOpcionesImpresion
            isOpen={mostrarModalImpresion}
            onClose={() => {
              console.log('Cerrando modal de opciones de impresión');
              setMostrarModalImpresion(false);
              setOpcionesImpresion(null);
              setWhatsappData(null);
            }}
            opciones={opcionesImpresion?.opciones || []}
            whatsappData={whatsappData}
            titulo="¡Pago Registrado Exitosamente!"
            onOpcionSeleccionada={(opcion) => {
              console.log('Opción seleccionada:', opcion.nombre);
            }}
          />
        </div>
      )}

      {/* Modal de acciones después del pago */}
      <ModalAccionesPago
        mostrar={mostrarModalAcciones}
        onCerrar={handleCerrarModalAcciones}
        pagoInfo={datosPagoGuardado}
        onImprimirRecibo={handleImprimirRecibo}
        onEnviarWhatsApp={handleEnviarWhatsApp}
      />
    </div>
  );
};

export default Pago;
